require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// /opt/wh/whtree/~/core-js/modules/es7.symbol.observable.js
// module id = 858
// module chunks = 0